import { z } from 'zod';
export const pipelineStatusSchema = z.enum([
    'Analyzing',
    'In Market',
    'LOI Submitted',
    'Under Contract',
    'Closed',
    'Passed',
]);
// Linear cycle (Passed is OUT of the cycle — a side action; Closed wraps to Analyzing — spec §8, design.md:184-185)
export const PIPELINE_STATUS_ORDER = [
    'Analyzing',
    'In Market',
    'LOI Submitted',
    'Under Contract',
    'Closed',
];
export function nextPipelineStatus(s) {
    // 'Passed' is not part of the linear cycle — calling next() on it is a no-op-return
    if (s === 'Passed')
        return 'Passed';
    const i = PIPELINE_STATUS_ORDER.indexOf(s);
    // 'Passed' is the ONLY non-ORDER member of the closed 6-value enum and is handled
    // above, so `i` is always 0..4 here; the modulo implements Closed→Analyzing wrap (spec §8).
    return PIPELINE_STATUS_ORDER[(i + 1) % PIPELINE_STATUS_ORDER.length];
}
// Framework-agnostic semantic tokens (web maps to Tailwind / CSS-var — spec §8; NOT a Tailwind class here)
export const PIPELINE_STATUS_COLOR_TOKEN = {
    Analyzing: 'status-analyzing',
    'In Market': 'status-in-market',
    'LOI Submitted': 'status-loi-submitted',
    'Under Contract': 'status-under-contract',
    Closed: 'status-closed',
    Passed: 'status-passed',
};
